import { makeStyles } from "@material-ui/core/styles";
import { useStateValue } from "../context/state/provider";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import BackIcon from "../images/backIcon.svg";
import { VIEW } from "../constants/view.constants";

// Safe iframe detection with error handling for cross-origin scenarios
function detectIframe() {
	try {
		return window.self !== window.top;
	} catch (e) {
		// If we can't access window.top due to cross-origin restrictions,
		// assume we're in an iframe for safety
		return true;
	}
}

const useStyles = makeStyles({
	avatar: props => ({
		backgroundImage: props.avatarUrl ? `url("${props.avatarUrl}")` : "var(--active-avatar-url)",
		backgroundPosition: "center",
		backgroundSize: "contain",
		borderRadius: "50%",
		height: "45px",
		width: "45px",
		marginRight: "10px",
		animation: "fadeIn 0.15s ease",
	}),
	backButton: {
		borderRadius: "9px",
		height: "47px",
		width: "47px",
		marginRight: "10px",
		"&:focus": {
			background: "rgba(0,0,0,0.2)",
		},
		"&:hover": {
			background: "transparent",
			opacity: "0.8",
		},
	},
	flexRow: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		animation: "fadeIn 0.15s ease",
	},
	botStatus: {
		color: "var(--bot-status)",
		fontSize: "10px",
		margin: "3px 5px 0 5px",
	},
	botTitle: props => ({
		fontSize: "17px",
		margin: 0,
		maxWidth: props.isEmbedded ? "140px" : "250px", // 140px in iframe, 250px standalone
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		textAlign: "left",
	}),
	accessibilityTitle: {
		fontSize: "18px",
		fontWeight: 400,
		textAlign: "left",
		animation: "fadeIn 0.15s ease",
	},
	subTitle: {
		fontSize: "13px",
		margin: 0,
		fontWeight: 400,
		textAlign: "start",
		animation: "fadeIn 0.15s ease",
	},
	"@media (max-width: 375px)": {
		botTitle: props => ({
			fontSize: "15px",
			maxWidth: props.isEmbedded ? "130px" : "200px", // Responsive sizing
		}),
		accessibilityTitle: {
			fontSize: "15px",
			marginRight: "5px",
		},
		subTitle: {
			fontSize: "12px",
		},
		avatar: {
			height: "40px",
			width: "40px",
		},
	},
});

export default function HeaderTitle({ brandingTitle, subtitle, avatarUrl }) {
	const isEmbedded = detectIframe();
	const classes = useStyles({ avatarUrl, isEmbedded });
	const [{ view }, dispatch] = useStateValue();

	const handleBackButton = () => {
		dispatch({
			type: "SET_VIEW",
			view: VIEW.CHATROOM,
		});
	};

	return (
		<div className={classes.flexRow}>
			{view === VIEW.CHATROOM ? (
				<div
					className={classes.avatar}
					// onError={handleAvatarError}
					role="img"
					aria-label="Avatar"
				/>
			) : (
				<Tooltip title="Back">
					<IconButton
						className={classes.backButton}
						onClick={() => {
							handleBackButton();
						}}
					>
						<img src={BackIcon} alt="Back" />
					</IconButton>
				</Tooltip>
			)}
			{view === VIEW.CHATROOM && (
				<div>
					<div className={classes.flexRow}>
						<h2 className={classes.botTitle}>{brandingTitle}</h2>
						<FiberManualRecordIcon className={classes.botStatus} />
					</div>
					{subtitle && <p className={classes.subTitle}>{subtitle} </p>}
				</div>
			)}
			{view === VIEW.ACCESSIBILITY && (
				<div>
					<h2 className={classes.accessibilityTitle}>
						Accessibility Options
					</h2>
				</div>
			)}

			{view === VIEW.SETTINGS && (
				<div>
					<h2 className={classes.accessibilityTitle}>
						Custom Settings
					</h2>
				</div>
			)}
			{view === VIEW.LOGIN && (
				<div>
					<h2 className={classes.accessibilityTitle}>
						Account Login
					</h2>
				</div>
			)}
		</div>
	);
}
